import React, { useEffect, useState } from "react";
import { reduxForm, Field, FieldArray } from "redux-form";
import { Button, Table } from "semantic-ui-react";
import {
  renderTextField,
  renderRadioField,
  renderTextAreaField,
} from "../formcomponents";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice, ImageUrl } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
import FileUpladArr from "./FileUplaad/FileUpladArr";
import "./CompanyEmpCreate.css";
const validate = (values) => {
  const errors = {};
  if (!values.visaCategory) {
    errors.workCvisaCategoryategory = "Required";
  }

  return errors;
};

const ComapnyEmpCreate = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { id, catId } = useParams();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [imageList, setimageList] = useState([]);
  const [deletingFileId, setDeletingFileId] = useState(null);
  const isEditMode = id !== "null";
  useEffect(() => {
    if (id !== "null") {
      getWorkList();
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
    }
  }, []);
  const getWorkList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/getCompanyEmployeeDetails", {
        companyEmployeeId: id,
      })
      .then((res) => {
        console.log(JSON.stringify(res.data, null, 2));
        const tempData = res.data;
        const filterData = tempData;
        console.log("filterData", filterData);

        initilizeData(filterData);
      })
      .catch((error) => console.log(error));
  };

  const initilizeData = (filterData) => {
    props.initialize({
      companyEmployeeId: filterData.companyEmployeeId,
      categoryId: filterData.categoryId,
      firstName: filterData.firstName,
      middleName: filterData.middleName,
      lastName: filterData.lastName,
      position: filterData.position,
      passportNumber: filterData.passportNumber,
      expiry: filterData.expiry,
      passportWithUs: filterData.passportWithUs,
      passportReturned: filterData.passportReturned,
      remarks: filterData.remarks,
      fileList: [{}],
    });
    setimageList(filterData.fileList);
  };
  const handleDeleteFile = (file) => {
    const fileStorageId = file.fileStorageId || file.fileId;
    if (!fileStorageId) {
      Swal.fire("Error", "File identifier missing.", "error");
      return;
    }
    setDeletingFileId(fileStorageId);
    axios
      .post(BaseUrl + "deleteFile", { fileStorageId })
      .then((res) => {
        const { errCode, errMessage } = res.data || {};
        if (errCode === 200 || errMessage === "Success" || res.data === "Success") {
          Swal.fire("Deleted", "File removed successfully", "success");
          setimageList((prev) =>
            prev.filter(
              (item) => (item.fileStorageId || item.fileId) !== fileStorageId
            )
          );
        } else {
          Swal.fire("Error", "Could not delete the file.", "error");
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire("Error", "Could not delete the file.", "error");
      })
      .finally(() => setDeletingFileId(null));
  };
  const sumbitForm = (values) => {
    const submitObject = {
      ...values,
      // Replace existing contactDetails with tempArr
      userId: userDetail.userId,
      categoryId: catId,
    };

    if (catId == 0) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Category IT is 0 please try again",
      });
    } else {
      console.log(JSON.stringify(submitObject, null, 2));
      axios
        .post(BaseUrlInvoice + "accounts/createCompanyEmployee", submitObject)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.errCode == 200) {
            Swal.fire({
              icon: "success",
              title: "sccess",
              text: "Created",
            });
            navigate(`/list-company-employee/${res.data.categoryId}`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  return (
    <div className="company-employee-shell">
      <div className="page-header-card">
        <div>
          <p className="eyebrow">Employee Management</p>
          <h1>Create Company Employee</h1>
          <p className="subtitle">
            Capture passport, role, and supporting files in a single, polished
            layout.
          </p>
          <div className="tag-row">
            <span className="tag">Category #{catId}</span>
            <span className="tag">{isEditMode ? `Editing #${id}` : "New record"}</span>
          </div>
        </div>
        <div className="header-hints">
          <div className="hint-card">Uploads stay attached to this employee.</div>
          <div className="hint-card secondary">
            Update passport custody and expiry in real time.
          </div>
        </div>
      </div>

      <div className="panel">
        <div className="panel-header">
          <div>
            <p className="eyebrow muted">Identity</p>
            <h2>Profile details</h2>
            <p className="helper-text">
              These fields power search and the employee list.
            </p>
          </div>
          <span className="pill">{isEditMode ? "Editing record" : "New entry"}</span>
        </div>
        <div className="panel-body two-col">
          <div className="form-field-block">
            <Field
              name="firstName"
              label="First Name"
              type="text"
              component={renderTextField}
            />
          </div>
          <div className="form-field-block">
            <Field
              name="middleName"
              label="Middle Name"
              type="text"
              component={renderTextField}
            />
          </div>
          <div className="form-field-block">
            <Field
              name="lastName"
              label="Last Name"
              type="text"
              component={renderTextField}
            />
          </div>
          <div className="form-field-block">
            <Field
              name="position"
              label="Position"
              type="text"
              component={renderTextField}
            />
          </div>
          <div className="form-field-block">
            <Field
              name="passportNumber"
              label="Passport Number"
              type="text"
              component={renderTextField}
            />
          </div>
        </div>
      </div>

      <div className="panel">
        <div className="panel-header">
          <div>
            <p className="eyebrow muted">Passport & Status</p>
            <h2>Document tracking</h2>
            <p className="helper-text">
              Keep custody status and expiry up to date for smooth handovers.
            </p>
          </div>
        </div>
        <div className="panel-body">
          <div className="two-col">
            <div className="form-field-block">
              <span className="radio-label">Passport With Us</span>
              <div className="radio-group">
                <Field
                  name="passportWithUs"
                  component={renderRadioField}
                  radioValue={true}
                  label="Yes"
                />
                <Field
                  name="passportWithUs"
                  component={renderRadioField}
                  radioValue={false}
                  label="No"
                />
              </div>
            </div>
            <div className="form-field-block">
              <span className="radio-label">Passport Returned</span>
              <div className="radio-group">
                <Field
                  name="passportReturned"
                  component={renderRadioField}
                  radioValue={true}
                  label="Yes"
                />
                <Field
                  name="passportReturned"
                  component={renderRadioField}
                  radioValue={false}
                  label="No"
                />
              </div>
            </div>
            <div className="form-field-block">
              <Field
                name="expiry"
                label="Expiry"
                type="date"
                component={renderTextField}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="panel">
        <div className="panel-header">
          <div>
            <p className="eyebrow muted">Files & Notes</p>
            <h2>Documents and remarks</h2>
            <p className="helper-text">
              Attach passports, IDs, or letters and keep a running note.
            </p>
          </div>
        </div>
        <div className="panel-body">
          <div className="upload-card">
            <FieldArray name="fileList" component={FileUpladArr} />
          </div>
          {imageList.length > 0 && (
            <div className="attachment-table">
              <Table celled className="company-employee-table">
                <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>File Name</Table.HeaderCell>
                  <Table.HeaderCell>Download Link</Table.HeaderCell>
                  <Table.HeaderCell>Action</Table.HeaderCell>
                </Table.Row>
                </Table.Header>
                <Table.Body>
                  {imageList.map((item, index) => (
                    <Table.Row key={index}>
                      <Table.Cell collapsing>{item.fileTypeName}</Table.Cell>
                      <Table.Cell collapsing>
                        <p
                          className="download-link"
                          onClick={() =>
                            window.open(
                              ImageUrl + item.fileName,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                        >
                          Download
                        </p>
                      </Table.Cell>
                    <Table.Cell collapsing>
                      <Button
                        basic
                        color="red"
                        size="small"
                        disabled={
                          buttonDisable ||
                          deletingFileId === (item.fileStorageId || item.fileId)
                        }
                        onClick={() => handleDeleteFile(item)}
                      >
                        {deletingFileId ===
                        (item.fileStorageId || item.fileId)
                          ? "Deleting..."
                          : "Delete"}
                      </Button>
                    </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
          <div className="remarks-block">
            <Field name="remarks" component={renderTextAreaField} label="Remarks" />
          </div>
        </div>
      </div>

      <div className="action-bar">
        <Button
          className="btn-secondary"
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>
        <Button
          className="btn-primary"
          disabled={buttonDisable}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default reduxForm({
  form: "ComapnyEmpCreate",
  validate,
})(ComapnyEmpCreate);
